import { render, staticRenderFns } from "./OrderListTd1.vue?vue&type=template&id=e66b875e&scoped=true"
import script from "./OrderListTd1.vue?vue&type=script&lang=js"
export * from "./OrderListTd1.vue?vue&type=script&lang=js"
import style0 from "./OrderListTd1.vue?vue&type=style&index=0&id=e66b875e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66b875e",
  null
  
)

export default component.exports